const APP_BAR = 1100
const DRAWER = APP_BAR - 1
export const Z_INDEX = {
  APP_BAR,
  DRAWER,
  SIDE_MOBILE_DRAWER: DRAWER - 1,
  CUSTOM_POPOVER: 100,
} as const
